import {
  PropType,
  computed,
  defineComponent,
  inject,
  ref,
} from 'vue';
import { Toast } from 'vant';
import { partition } from 'lodash';
import router from '@/router/index';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  BikeBizId, Package, getPlatform, getBikeAdSource,
} from '~mall/constants/bike';
import { getStylesBinder } from '~mall/common/utils/styles';
import { reqBuyBikeCard, reqOrderPay } from '~mall/model/apis/bike';
import { getCouponMallUrlNew } from '~mall/model/utils';
import nativeMgr from '~mall/common/native/native';
import { ModuleExposeOptions } from '~mall/common/directives/v-expose';
import { appQueryConfig } from '~mall/common/utils/url';
import store from '~mall/model/store';
import { uiMgr } from '~mall/common/uiMgr';
import { RouterTicketDetail } from '~mall/constants/routerConstants';
import TicketDetailNewPop from '../../TicketDetailNewPop/index';
import SlideNewPopUp from '../../SlideNewPopUp/index.vue';
import { NetError } from '~mall/common/network/err';
import { onDetailPopupOpen, onDetailPopupClose, onCashierTrigger } from '~mall/common/utils/widgetGuide';
import { formatPrice, splitTitle, renderPrice } from '../../../util';
import styles from './index.module.less';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'CardListItem',
  props: {
    // 超值精选标记
    highRecm: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object as PropType<Package | null>,
      required: true,
    },
    bizId: {
      type: Number as PropType<BikeBizId>,
      required: true,
    },
    channelCode: {
      type: Number,
      required: true,
    },
    paySuccessCb: {
      type: Function as PropType<{ (): void }>,
      default: () => ({}),
    },
    categoryName: {
      type: String,
      default: '',
    },
    tabCategoryName: {
      type: String,
      default: '',
    },
    categoryId: {
      type: String,
      default: '',
    },
    traceId: {
      type: String,
      default: '',
    },
    skuIndex: {
      type: Number,
      required: true,
    },
  },
  setup: (props) => {
    const styleVersion = inject('styleVersion');
    /** 当前是否购买中——防重复点击 */
    const buying = ref(false);
    /** 是否展示新半浮层 */
    const showNewPopup = ref(false);
    /** 优惠标签和普通文本 */
    const tagsAndWords = computed(() => partition(
        props.data?.marketingWords || [],
        ({ wordsType }) => wordsType === 1,
    ));
      // * store中的数据
    const defaultCity = computed(() => store.state.city.defaultCity);
    /** 是否在北京 */
    const isBeijing = computed(() => defaultCity.value === '北京市');

    /** 公共UBT参数 */
    const commonUbtBizInfo = computed(() => ({
      packageGuid: props.data?.packageGuid,
      adsource: appQueryConfig.adsource,
      categoryid: props.categoryId,
    }));

    /** 购买点击UBT参数 */
    const buyBtnUbtBizInfo = computed(() => ({
      ...commonUbtBizInfo.value,
      goodsName: props.data?.showName,
      twoWheelCardInfo: JSON.stringify(props.data),
    }));

    /** 卡券card 模块点击UBT参数 */
    const cardClickUbtBizInfo = computed(() => ({
      ...commonUbtBizInfo.value,
      experimentalGroup: styleVersion,
      algoTraceID: props.traceId,
      tabName: props.tabCategoryName,
      originalPrice: props.data?.originPrice,
      salePrice: props.data?.actualPrice.finalPrice,
      itemNo: props.skuIndex + 1,
      isSupervalue: props.highRecm,
    }));
    /** 模块曝光选项 */
    const cardUbtExpose = computed<ModuleExposeOptions>(() => ({
      exposeData: {
        pageId: "platform_couponmall",
        categoryId: "platform",
        moduleId: "platform_couponmalltwowheels",
        contentId: "platform_couponmalltwowheels",
        exposureTimes: 1,
        businessInfo: cardClickUbtBizInfo.value,
      },
    }));
    const buyBtnUbtExpose = computed<ModuleExposeOptions>(() => ({
      exposeData: {
        pageId: "platform_couponmall",
        categoryId: "platform",
        moduleId: "platform_twowheelsgopay",
        contentId: "platform_twowheelsgopay",
        exposureTimes: 1,
        businessInfo: buyBtnUbtBizInfo.value,
      },
    }));
    const handleClose = () => {
      // showPopup.value = false;
      showNewPopup.value = false;
      // 详情弹窗关闭，恢复小组件弹窗
      onDetailPopupClose();
    };
      /** 处理点击购买 */
    const handleBuy = async () => {
      if (buying.value) {
        return;
      }
      // 收银台触发，取消小组件弹窗
      onCashierTrigger();
      if (isBeijing.value) {
        const query = {
          ...router.app.$route.query,
          isTwBikeStr: '1',
          isFromList: '1',
          categoryName: props.categoryName,
          highRecm: props.highRecm,
          channelCodeStr: props.channelCode,
          bizIdStr: props.bizId,
          twBikeStr: JSON.stringify(props.data),
        } as any;
          // 跳转详情
        uiMgr.pushPage({
          name: RouterTicketDetail.name,
          query,
        });
        return;
      }

      buying.value = true;
      /** 下单成功生成的订单数据 */
      let data: Awaited<ReturnType<typeof reqBuyBikeCard>> = null;

      try {
        const {
          channelCode,
          bizId,
          data: pkg,
        } = props;
        const cityInfo = await nativeMgr.getCityInfo();
        const {
          cityCode = '',
          adCode = '',
          latitude = '',
          longitude = '',
        } = cityInfo || {};
        const {
          packageGuid,
          actualPrice,
          pendingInfos,
        } = pkg!;
        data = await reqBuyBikeCard({
          _uuid: window.$$user.userGuid,
          cityCode,
          adCode,
          location: {
            lat: latitude,
            lng: longitude,
          },
          bizContent: {
            businessType: bizId === BikeBizId.BICYCLE
              ? 1
              : 2,
            channelCode,
            totalPrice: actualPrice.finalPrice,
            packageList: [{
              packageGuid,
              actualPrice,
              pendingInfos,
              category: 1,
            }],
          },
          packagePlatform: getPlatform(),
          version: (await nativeMgr.getDeviceInfo()).version,
          adSource: getBikeAdSource(),
        });
      } catch (e) {
        if (e instanceof Error) {
          Toast((e as NetError).netErrMsg || e.message || '未知错误');
        }
      } finally {
        // ! 下单结束先释放购买按钮的点击
        buying.value = false;
      }

      if (!data) {
        return;
      }

      try {
        await reqOrderPay({
          ...data,
          returnUrl: getCouponMallUrlNew(),
          wechatSignTempId: props.data?.wechatSignTempId,
          monthlySub: props.data?.paymentLimit === 1,
        });
        props.paySuccessCb();
      } catch (e) {
        if (e instanceof Error) {
          Toast(e.message);
        }
      }
    };
      /** 处理点击 */
    const handleCardClick = async () => {
      // 新半浮层样式
      showNewPopup.value = true;
      // 详情弹窗打开，暂停小组件弹窗
      onDetailPopupOpen();
    };

    // 渲染标题，区分数字和非数字样式
    const renderTitle = (title: string) => {
      const parts = splitTitle(title);

      return parts.map((part, index) => (
        <span
          key={index}
          class={cx(part.isNumber ? 'card__title-number' : 'card__title-text')}
        >
          {part.text}
        </span>
      ));
    };

    // 渲染价格，小数部分字号单独处理
    const renderPriceJSX = (price: string) => {
      const { integer, hasDecimal, decimal } = renderPrice(price);

      if (!hasDecimal) {
        return integer;
      }

      return [
        integer,
        <span class={cx('card__price-dot')}>.</span>,
        <span class={cx('card__price-decimal')}>{decimal}</span>,
      ];
    };

    return () => {
      if (!props.data) {
        return null;
      }

      const {
        showName,
        originPrice,
        actualPrice: {
          finalPrice,
        },
      } = props.data;
      const [tags, words] = tagsAndWords.value;
      return (
        <div>
          <div
            class={cx('card')}
            onClick={() => {
              UBT.clickButton({
                pageId: "platform_couponmall",
                buttonName: "platform_couponmalltwowheels",
                categoryId: "platform",
                businessInfo: cardClickUbtBizInfo.value,
              });
              handleCardClick();
            }}
            v-node-expose={cardUbtExpose.value}
          >
            <div class={cx('card__logo-wrap', 'card__logo-wrap-new')}>
              <van-image
                class={cx('card__logo')}
                src={props.categoryName === '单车' ? 'https://m.hellobike.com/resource/gallery/290/mEKGXEmP-B.png?x-oss-process=image/quality,q_80' : 'https://m.hellobike.com/resource/gallery/290/bdgBk4OhZq.png?x-oss-process=image/quality,q_80'}
              />
            </div>
            <div class={cx('card__content-new')}>
              <div class={cx('card__content-left')}>
                <div class={cx('card__info', 'card__title-new')}>{renderTitle(showName)}</div>
                {words && words.length > 0 && (
                  <div class={cx('card__info', 'card__desc-listnew')}>
                    {words.slice(0, 2).map(({ wordsValue }, index) => (
                      <div
                        key={index}
                        class={cx(
                          index === 0 ? 'card__desc-tag_first' : 'card__desc-tag_second',
                        )}
                      >
                        {wordsValue}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div class={cx('card__content-right')}>
                <div class={cx('card__price-container')}>
                  <div class={cx('card__buy-price-new')}>
                    {renderPriceJSX(finalPrice)}
                  </div>

                  <div class={cx('card__origin-price-new')}>
                    {formatPrice(originPrice)}
                  </div>

                </div>
                <div
                  class={cx('card__buy-new')}
                  onClick={(e) => {
                    e.stopPropagation();
                    UBT.clickButton({
                      pageId: "platform_couponmall",
                      buttonName: "platform_twowheelsgopay",
                      categoryId: "platform",
                      businessInfo: buyBtnUbtBizInfo.value,
                    });
                    handleBuy();
                  }}
                  v-node-expose={buyBtnUbtExpose.value}
                >购买</div>
              </div>
            </div>
          </div>
          <SlideNewPopUp
            show={showNewPopup.value}
            on-close={handleClose}
            on-click-overlay={handleClose}
            get-container="#app"
            scopedSlots={{
              content: ({
                fullScreen,
                getRef,
                height,
                transform,
                transition,
              }: {
                fullScreen: boolean;
                getRef: (el: HTMLElement) => void;
                height: string;
                transform: string;
                transition: string;
              }) => (
                showNewPopup.value && (
                  <TicketDetailNewPop
                    query={{
                      ...router.app.$route.query,
                      isTwBikeStr: '1',
                      isFromList: '1',
                      categoryName: props.categoryName,
                      categoryId: props.categoryId,
                      channelCodeStr: props.channelCode,
                      bizIdStr: props.bizId,
                      twBikeStr: JSON.stringify(props.data),
                      highRecm: props.highRecm,
                    }}
                    full-screen={fullScreen}
                    get-ref={getRef}
                    height={height}
                    transform={transform}
                    transition={transition}
                  />
                )
              ),
            }}
          />
        </div>
      );
    };
  },
});
